export const UOM_DEFAULT_DECIMALS = 2;

export enum Unit {
    m = "m",
    m2 = "m2",
    m3 = "m3",
    mm = "mm",
    mm2 = "mm2",
    mm3 = "mm3",
    ft = "ft",
    ft2 = "ft2",
    ft3 = "ft3",
    in = "in",
    uin = "uin",
    uin2 = "uin2",
    uin3 = "uin3",
    deg = "deg",
    rad = "rad",
    mil = "mil",
    mil2 = "mil2",
    mil3 = "mil3",
    um = "um",
    um2 = "um2",
    um3 = "um3",
    // "cd/m2": { abbreviation: "cd/m2" },
}

export type UnitInfo = {
    abbreviation: string;
    decimals?: number;
};

export const UNITS: { [key in Unit]: UnitInfo } = {
    m: { abbreviation: "m" },
    m2: { abbreviation: "m²" },
    m3: { abbreviation: "m³" },
    mm: { abbreviation: "mm" },
    mm2: { abbreviation: "mm²" },
    mm3: { abbreviation: "mm³" },
    ft: { abbreviation: "ft" },
    ft2: { abbreviation: "ft²" },
    ft3: { abbreviation: "ft³" },
    in: { abbreviation: "in" },
    deg: { abbreviation: "°", decimals: 1 },
    rad: { abbreviation: "rad" },
    uin: { abbreviation: "µin" },
    uin2: { abbreviation: "µin²" },
    uin3: { abbreviation: "µin³" },
    mil: { abbreviation: "mil" },
    mil2: { abbreviation: "mil²" },
    mil3: { abbreviation: "mil³" },
    um: { abbreviation: "µm" },
    um2: { abbreviation: "µm²" },
    um3: { abbreviation: "µm³" },
    // "cd/m2": { abbreviation: "cd/m²" },
};

export enum UnitType {
    length = "length",
    area = "area",
    volume = "volume",
    angle = "angle",
}

export type UnitTypeInfo = {
    abbreviation: string;
    baseUnit: Unit;
};

export const UNIT_TYPES: { [key in UnitType]: UnitTypeInfo } = {
    length: { abbreviation: "L" as const, baseUnit: Unit.m },
    area: { abbreviation: "A" as const, baseUnit: Unit.m2 },
    volume: { abbreviation: "V" as const, baseUnit: Unit.m3 },
    angle: { abbreviation: "An" as const, baseUnit: Unit.deg },
    // luminance: { abbreviation: "lum" as const, baseUnit: Unit["cd/m2"] },
};

export const UNIT_TYPE_BY_ABBREVIATION = new Map<string, UnitType>();
for (const [key, value] of Object.entries(UNIT_TYPES)) {
    UNIT_TYPE_BY_ABBREVIATION.set(value.abbreviation, key as UnitType);
}

export enum UnitSystem {
    metric = "metric",
    metricMM = "metricMM",
    imperial = "imperial",
}

export type UnitSystemInfo = {
    unitTypes: { [key in UnitType]: Unit };
};

export const UNIT_SYSTEMS: { [key in UnitSystem]: UnitSystemInfo } = {
    metric: {
        unitTypes: {
            [UnitType.length]: Unit.m,
            [UnitType.area]: Unit.m2,
            [UnitType.volume]: Unit.m3,
            [UnitType.angle]: Unit.deg,
            // luminance: "cd/m2",
        },
    },
    metricMM: {
        unitTypes: {
            [UnitType.length]: Unit.mm,
            [UnitType.area]: Unit.mm2,
            [UnitType.volume]: Unit.mm3,
            [UnitType.angle]: Unit.deg,
            // luminance: "cd/m2",
        },
    },
    imperial: {
        unitTypes: {
            [UnitType.length]: Unit.ft,
            [UnitType.area]: Unit.ft2,
            [UnitType.volume]: Unit.ft3,
            [UnitType.angle]: Unit.deg,
            // luminance: "cd/m2",
        },
    },
};

export type FormatOptions = {
    decimals?: number;
};
